/**
 * @desc 待处理信息提交（导出报关箱单）
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(sourceNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/dclCustomsClearance/${sourceNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
